import { CheckoutPaymentCore } from './CheckoutPaymentCore'

const CheckoutPayment = () => <CheckoutPaymentCore />
export default CheckoutPayment
